import React from "react";
import {XCircleIcon} from "@heroicons/react/20/solid";

export default class Alert extends React.Component {

    render() {

        const colorVariants = {
            red: {
                bg: "bg-red-50",
                icon: "text-red-400",
                header: "text-red-800",
                description: "text-red-700"
            },
            green: {
                bg: "bg-green-50",
                icon: "text-green-400",
                header: "text-green-800",
                description: "text-green-700"
            }
        }

        console.log(colorVariants)

        return (
            <div className={`rounded-md mt-6 ${colorVariants[this.props.color].bg} p-4`}>
                <div className="flex">
                    <div className="flex-shrink-0">
                        <XCircleIcon className={`h-5 w-5 ${colorVariants[this.props.color].icon}`} aria-hidden="true"/>
                    </div>
                    <div className="ml-3">
                        <h3 className={`text-sm font-medium ${colorVariants[this.props.color].header}`}>{this.props.header}</h3>
                        <div className={`mt-2 text-sm ${colorVariants[this.props.color].description}`}>
                            <p>
                                {this.props.description}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
